import { createContext, useState } from "react";
import { Dexie } from "dexie";

export const GlobalContext = createContext();

const db = new Dexie("code-red");
db.version(1).stores({
  users: "_id,username",
  appointments: "_id,start,end,completed",
  forms: "[appointmentId+type+version],appointmentId",
});

const GlobalProvider = ({ children }) => {
  const [title, setTitle] = useState("Code Red");
  const [user, setUser] = useState(null);

  return (
    <GlobalContext.Provider value={{ user, setUser, title, setTitle, db }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;
